import { render, staticRenderFns } from "./FMMoveDialog.vue?vue&type=template&id=65f308ce&scoped=true"
import script from "./FMMoveDialog.vue?vue&type=script&lang=js"
export * from "./FMMoveDialog.vue?vue&type=script&lang=js"
import style0 from "./FMMoveDialog.vue?vue&type=style&index=0&id=65f308ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f308ce",
  null
  
)

export default component.exports